// extracted by mini-css-extract-plugin
export default {"container":"CollectionDetails_container__Nmnzz","subContainer":"CollectionDetails_subContainer__mYvCJ"};